export const defaultThickness = {
	metric: 90,
	imperial: 3.5,
} as const satisfies Record<'metric' | 'imperial', number>;

export const defaultCmuThickness = {
	metric: 200,
	imperial: 8,
} as const satisfies Record<'metric' | 'imperial', number>;
